module.exports = "/images/scotiabank.svg?978805a4efb52cdef30b071a7fc3bc43";